import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../utilities/TabGrid";
import {TopButtonPointEdit, TopButtonPointRemove} from "../../../../../componentsTopsa/buttons/TopButtons";
import TabUtilities from "../../../../../utilities/TabUtilities";
import DateAndTimeFormat from "../../../../../utilities/DateAndTimeFormat";

export default class PromocjeTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
        this.renderTyp = this.renderTyp.bind(this)
        this.formatGodzina = this.formatGodzina.bind(this)
        this.formatIloscBiletow = this.formatIloscBiletow.bind(this)
        this.formatSprzedazBiletow = this.formatSprzedazBiletow.bind(this)
        this.formatWartosc = this.formatWartosc.bind(this)
        this.formatPozostaleDane = this.formatPozostaleDane.bind(this)

    }

    renderButtonyAkcji(cell, row) {
        if(this.sprawdzCzyPromocjaMinela(row.dataDo)){
            return(<div style={{fontSize:'12px', color:'peru'}}>
                <i className={'fa fa-exclamation-circle'}></i> Promocja zakończona
            </div>)
        }
        else if(row.ileBilSprz>0){
            return(<div style={{fontSize:'12px', color:'firebrick'}}>
                <i className={'fa fa-exclamation-circle'}></i> Edycja zabroniona
            </div>)
        }
        else
        return (
            <div>
                <TopButtonPointEdit onClick={() => {
                    this.props.handleEdytuj(row)
                }} titleContent={'Edytuj promocję'}/>
                <TopButtonPointRemove onClick={() => {
                    this.props.handleUsun(row)
                }} titleContent={'Usuń promocję'}/>
            </div>
        )
    }

    renderTyp(cell, row) {
        return(<span style={this.sprawdzCzyPromocjaMinela(row.dataDo)? {opacity:'0.5'}:{}}>{(cell === 0 || cell === 1)? 'dokładnie od do' : 'na całym odcinku'}</span>)
    }

    formatGodzina(cell, row) {
        return <span style={this.sprawdzCzyPromocjaMinela(row.dataDo)? {opacity:'0.5'}:{}}>{DateAndTimeFormat.formatNormalTime(cell)}</span>
    }

    formatIloscBiletow(cell, row) {
        return <span style={this.sprawdzCzyPromocjaMinela(row.dataDo)? {opacity:'0.5'}:{}}>{(cell === null || cell === 0)? '-':cell}</span>
    }

    formatWartosc(cell, row) {
        return <span style={this.sprawdzCzyPromocjaMinela(row.dataDo)? {opacity:'0.5'}:{}}>{(row.typ % 2 == 0)?cell+' PLN':cell+' %'}</span>
    }

    sprawdzCzyPromocjaMinela(data){
        let obecna = new Date().toJSON().substr(0,10)

        return(data<obecna)
    }

    formatSprzedazBiletow(cell, row) {
        if (Boolean(row.ileBilSuma)) {
            let pozostalo = parseInt(row.ileBilSuma) - parseInt(cell)

            let procent = Math.ceil((parseInt(cell) * 100) / parseInt(row.ileBilSuma))


            return (<div  style={this.sprawdzCzyPromocjaMinela(row.dataDo)? {opacity:'0.7'}:{}}>
                <div style={{color: 'grey', fontStyle: 'italic', marginBottom:'3px'}}>
                    Sprzedano <span
                    style={{fontWeight: 'bold'}}>{cell}</span> z {row.ileBilSuma} biletów ({procent}%)
                </div>
                <div style={{fontSize:'12px'}}>
                    {
                        (procent === 100) ?
                            <span className={'label label-danger'} style={{fontSize:'inherit'}}>Wyprzedano bilety!</span>
                            :
                            (procent >= 90) ?
                                <span className={'label label-danger'} style={{fontSize:'inherit'}}>Pozostało {pozostalo} biletów</span>
                                :
                                (procent >= 60) ?
                                    <span className={'label label-warning'} style={{fontSize:'inherit'}}>Pozostało {pozostalo} biletów</span>
                                    :
                                    <span className={'label label-success'} style={{fontSize:'inherit'}}>Pozostało {pozostalo} biletów</span>
                    }
                </div>
            </div>)
        }
        else
            return <div style={this.sprawdzCzyPromocjaMinela(row.dataDo)? {opacity:'0.7'}:{}}><span style={{color: 'grey', fontStyle: 'italic'}}>Sprzedano <span style={{fontWeight: 'bold'}}>{cell}</span> biletów</span></div>
    }

    formatPozostaleDane(cell,row){
        return <span style={this.sprawdzCzyPromocjaMinela(row.dataDo)? {opacity:'0.5'}:{}}>{cell}</span>
    }

    render() {

        let typy = {
            0: "dokładnie od do PLN",
            1: "dokładnie od do %",
            2: "na całym odcinku PLN",
            3: "na całym odcinku %"
        }

        const options = {
            sizePerPage: 15,  // Showing 30 for the size per page as default
            sizePerPageList: [10, 15, 30],
            sortName: "dataOd",
            sortOrder: "DESC",
            noDataText: 'Brak pasujących rekordów'
        };
        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                >
                    <TableHeaderColumn dataField='idPro' isKey thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1} dataSort
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatPozostaleDane}
                    >Kod</TableHeaderColumn>
                    <TableHeaderColumn dataField='dataOd' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatPozostaleDane}
                    >Rozpoczęcie</TableHeaderColumn>
                    <TableHeaderColumn dataField='dataDo' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatPozostaleDane}
                    >Zakończenie</TableHeaderColumn>
                    <TableHeaderColumn dataField='godzOd'
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatGodzina}
                    >G. od</TableHeaderColumn>
                    <TableHeaderColumn dataField='godzDo'
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatGodzina}
                    >G. do</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazTr' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatPozostaleDane}
                    >Trasa</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazMiOd'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatPozostaleDane}
                    >Miejscowość od</TableHeaderColumn>
                    <TableHeaderColumn dataField='nazMiDo'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatPozostaleDane}
                    >Miejscowość do</TableHeaderColumn>
                    <TableHeaderColumn dataField='typ' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={{type: 'SelectFilter', options: typy, selectText: ''}} formatExtraData={typy}
                                       dataFormat={this.renderTyp}
                    >Typ</TableHeaderColumn>
                    <TableHeaderColumn dataField='wart' dataSort
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatWartosc}
                    >Wartość</TableHeaderColumn>
                    <TableHeaderColumn dataField='ileBiletow' dataSort
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatIloscBiletow}
                    >Ilość biletów / kurs</TableHeaderColumn>
                    <TableHeaderColumn dataField='ileBilSuma' dataSort
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatIloscBiletow}
                    >Ilość biletów (suma)</TableHeaderColumn>
                    <TableHeaderColumn dataField='ileBilSprz' dataSort
                                       thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.formatSprzedazBiletow}
                    >Sprzedaż biletów</TableHeaderColumn>
                    <TableHeaderColumn dataField='idPro'
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       dataFormat={this.renderButtonyAkcji}
                    >{TabUtilities.returnAkcjeEdytujUsunHtml()}</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/promocje/components/PromocjeTable.js